import scrollToItem from "./helpers/scrollToItem.js";

const support = () => {
	if (!document.querySelector("#support")) return;
	scrollToItem();

	/** поведение блоков при выборе option * */
	document.querySelectorAll("[data-select-collapse]").forEach((select) => select.addEventListener("change", function () {
		const { selectCollapse } = this.dataset;
		const idShow = this.value;
		const $rootCollapse = document.querySelector(selectCollapse);
		const $showCollapse = document.querySelector(idShow);

		if (!$rootCollapse || !$showCollapse) return;

		/** Пробегаемся по элементам выбора продукции и оставляем видимым только выбранное значение */
		$rootCollapse.querySelectorAll(`[data-item-collapse="${selectCollapse}"]`).forEach((item) => {
			const isHidden = item.id !== idShow.substr(1);

			item.classList.toggle("d-none", isHidden);
		});
	}));
	const select = document.querySelector(".support__select");

	select.addEventListener("change", (event) => {
		/** Пробегаемся по элементам выбора продукции и оставляем видимым только выбранное значение */
		document.querySelectorAll("[data-support-product]").forEach((item) => {
			const isHidden = item.dataset.supportProduct !== event.target.value;

			item.classList.toggle("d-none", isHidden);
		});
	});
	/** --- поведение блоков при выборе option * */
};

support();
